import {
  IBalanceOfTrade,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { useTableActions } from 'legacy/lut/components/widgets/public/partner360/ELT/hooks/useTableActions'
import { changeBalanceOfTrade } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/balanceOfTrade/helpers/changeBalanceOfTrade'
import { getBoTColumns } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/balanceOfTrade/helpers/getBoTColumns'
import { StyledTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import React, { useMemo } from 'react'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

const keyField = 'Key'

interface IProps {
  fYear: number
  balanceOfTradeData: IBalanceOfTrade[]
  updateFormData: (data: TComplexSectionData) => void
  netNdpValue: ActualsValueTypes
}

export const BalanceOfTradeTable = ({
  balanceOfTradeData,
  updateFormData,
  fYear,
  netNdpValue,
}: IProps) => {
  const { onChangeByKey } = useTableActions<IBalanceOfTrade>({
    updateFormData: updateFormData,
    data: balanceOfTradeData,
    changeComputedFieldsFn: changeBalanceOfTrade,
  })

  const columns = useMemo(
    () =>
      getBoTColumns({
        onChange: onChangeByKey(keyField),
        currentYear: fYear,
        netNdpValue: netNdpValue,
      }),
    [onChangeByKey, fYear, netNdpValue]
  )

  return (
    <div>
      <StyledTable<IBalanceOfTrade>
        columns={columns}
        items={balanceOfTradeData}
        keyField={keyField}
      />
    </div>
  )
}
